/**
 * Mega-menu app shots (Forge + Clap, partials/menu.jade).
 *
 * The Browse dropdown is in the DOM on every page, hidden with opacity, so
 * plain <img src> would download both shots for every visitor. They carry
 * data-menu-src instead and get their src the first time the dropdown opens
 * (ForgeGate watches the same .active / .active-touch classes header.sass
 * reveals it on).
 */
(function () {
  function load(img) {
    if (img.getAttribute("src")) return;
    img.onload = function () {
      img.classList.add("is-loaded");
    };
    img.src = img.getAttribute("data-menu-src");
  }

  function init() {
    var imgs = document.querySelectorAll("img[data-menu-src]");
    if (!imgs.length || !window.ForgeGate) return;
    var gate = window.ForgeGate.make(imgs[0]);
    function loadAll() {
      for (var i = 0; i < imgs.length; i++) load(imgs[i]);
    }
    if (gate.isOpen()) return loadAll();
    gate.watch(function (open) {
      if (open) loadAll();
    });
    // Warm the cache on hover intent, a beat before the panel opens
    var cell = imgs[0].closest && imgs[0].closest(".header__cell");
    if (cell) cell.addEventListener("mouseenter", loadAll, { once: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
